import { createImageApi } from './imageApi';
const api = createImageApi('mission-images', 'mission');
export function uploadMissionImage(data) {
    return api.upload(data);
}
export function getMissionImages(levelId) {
    return api.list(levelId);
}
export function getArchivedMissionImages(levelId) {
    return api.listArchived(levelId);
}
export function archiveMissionImage(id) {
    return api.archive(id);
}
export function restoreMissionImage(id) {
    return api.restore(id);
}
export function deleteMissionImagePermanent(id) {
    return api.deletePermanent(id);
}
